module.exports = __webpack_public_path__ + "img/cabin-side.ac9846be.jpg";